/**
 * useTextureState - 常量定义
 */

/**
 * 默认最大分辨率
 */
export const 默认最大分辨率 = 4096

/**
 * 默认边框大小
 */
export const 默认边框大小 = 0

/**
 * 分割位置初始值
 */
export const 分割位置初始值 = 0.5

/**
 * 缩放层级初始值
 */
export const 缩放层级初始值 = 1

/**
 * 未知模式标识
 */
export const 未知模式标识 = 'unknown'
